(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('comune', {
            parent: 'entity',
            url: '/comune',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'doctorclubboApp.comune.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/comune/comunes.html',
                    controller: 'ComuneController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('comune');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('comune-detail', {
            parent: 'entity',
            url: '/comune/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'doctorclubboApp.comune.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/comune/comune-detail.html',
                    controller: 'ComuneDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('comune');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Comune', function($stateParams, Comune) {
                    return Comune.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'comune',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('comune-detail.edit', {
            parent: 'comune-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/comune/comune-dialog.html',
                    controller: 'ComuneDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Comune', function(Comune) {
                            return Comune.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('comune.new', {
            parent: 'comune',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/comune/comune-dialog.html',
                    controller: 'ComuneDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                sigla: null,
                                comune: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('comune', null, { reload: 'comune' });
                }, function() {
                    $state.go('comune');
                });
            }]
        })
        .state('comune.edit', {
            parent: 'comune',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/comune/comune-dialog.html',
                    controller: 'ComuneDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Comune', function(Comune) {
                            return Comune.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('comune', null, { reload: 'comune' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('comune.delete', {
            parent: 'comune',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/comune/comune-delete-dialog.html',
                    controller: 'ComuneDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Comune', function(Comune) {
                            return Comune.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('comune', null, { reload: 'comune' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
